export var deprecatedMsg = function (msg) {
    if (process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line:no-console
        console.log("%c Deprecated:%c ".concat(msg), 'background: #fac249; color: #000; font-weight: bold', '');
    }
};
//# sourceMappingURL=index.js.map